import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as Yup from 'yup';
import { addBusinessDays } from 'date-fns';
import { Text } from '@yoweb/ui/components/typography';
import { Grid } from '@yoweb/ui/components/Grid';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { DatePicker } from '@yoweb/ui/components/DatePicker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getDateInitialValues = function getDateInitialValues(dateAnswer) {
  var _dateAnswer$answeredD;

  return dateAnswer === null || dateAnswer === void 0 ? void 0 : (_dateAnswer$answeredD = dateAnswer.answeredDate) === null || _dateAnswer$answeredD === void 0 ? void 0 : _dateAnswer$answeredD.seconds;
};
export var getDateValidationSchema = function getDateValidationSchema(isOptional, t) {
  return Yup.date().when(I_DO_NOT_KNOW_ID, {
    is: true,
    then: Yup.date(),
    otherwise: isOptional ? Yup.date() : Yup.date().required(t('validation.required', {
      ns: 'common'
    }))
  });
};
export var DateElement = function DateElement(_ref) {
  var _formikProps$values, _formikProps$values$q, _formikProps$values2, _formikProps$values2$;

  var instructionHint = _ref.instructionHint,
      dateAnswer = _ref.dateAnswer,
      isDisabled = _ref.isDisabled,
      id = _ref.id,
      formikProps = _ref.formikProps;

  var _id$split = id.split('.'),
      _id$split2 = _slicedToArray(_id$split, 2),
      questionId = _id$split2[0],
      index = _id$split2[1];

  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small2",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), /*#__PURE__*/_jsx(DatePicker, {
      label: (dateAnswer === null || dateAnswer === void 0 ? void 0 : dateAnswer.inputFieldHint) || '--',
      id: id,
      name: id,
      disabled: isDisabled,
      minDate: addBusinessDays(new Date(), 3),
      selected: formikProps !== null && formikProps !== void 0 && (_formikProps$values = formikProps.values) !== null && _formikProps$values !== void 0 && (_formikProps$values$q = _formikProps$values[questionId]) !== null && _formikProps$values$q !== void 0 && _formikProps$values$q[index] ? new Date((formikProps === null || formikProps === void 0 ? void 0 : (_formikProps$values2 = formikProps.values) === null || _formikProps$values2 === void 0 ? void 0 : (_formikProps$values2$ = _formikProps$values2[questionId]) === null || _formikProps$values2$ === void 0 ? void 0 : _formikProps$values2$[index]) * 1000) : undefined,
      onChange: function onChange(date, event) {
        var _target;

        var value = event === null || event === void 0 ? void 0 : (_target = event.target) === null || _target === void 0 ? void 0 : _target.value;

        if (value === '') {
          formikProps.setFieldValue(id, undefined);
        } else if (date) {
          formikProps.setFieldValue(id, date.getTime() / 1000);
        }
      }
    })]
  }, id);
};